import React, { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { X, ZoomIn } from "lucide-react";

const MENU_IMAGES = [
  { id: "shots", src: "/menus/shots-menu.webp", alt: "Soho69 Shots Menu" },
  { id: "drinks", src: "/menus/drink-menu.webp", alt: "Soho69 Drink Menu" },
];

function Lightbox({ img, onClose }) {
  const [zoomed, setZoomed] = useState(false);
  useEffect(() => {
    const onKey = (e) => e.key === "Escape" && onClose();
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    window.addEventListener("keydown", onKey);
    return () => {
      document.body.style.overflow = prev;
      window.removeEventListener("keydown", onKey);
    };
  }, [onClose]);

  return createPortal(
    <div
      data-testid="menu-lightbox"
      className="fixed inset-0 z-[100] bg-black overflow-auto"
      style={{ touchAction: "pinch-zoom pan-x pan-y" }}
      onClick={onClose}
    >
      <button
        type="button"
        data-testid="menu-lightbox-close"
        aria-label="Close"
        onClick={onClose}
        className="fixed top-4 right-4 z-[101] w-11 h-11 rounded-full bg-black/70 border border-neon text-white flex items-center justify-center"
      >
        <X size={22} />
      </button>
      <div className="min-h-full flex items-center justify-center p-2">
        <img
          src={img.src}
          alt={img.alt}
          data-testid="menu-lightbox-image"
          onClick={(e) => {
            e.stopPropagation();
            setZoomed((z) => !z);
          }}
          className={zoomed ? "max-w-none w-[200%] cursor-zoom-out" : "max-w-full max-h-[100dvh] object-contain cursor-zoom-in"}
        />
      </div>
    </div>,
    document.body
  );
}

export function MenuImages() {
  const [open, setOpen] = useState(null);
  const [missing, setMissing] = useState({});
  const visible = MENU_IMAGES.filter((m) => !missing[m.id]);
  if (!visible.length) return null;

  return (
    <div className="max-w-3xl mx-auto px-4 md:px-8 mt-4 space-y-5" data-testid="menu-images">
      {visible.map((m) => (
        <button
          key={m.id}
          type="button"
          data-testid={`menu-image-${m.id}`}
          onClick={() => setOpen(m)}
          className="relative block w-full rounded-2xl overflow-hidden border border-neon/40 shadow-[0_0_30px_rgba(255,27,141,0.25)] transition-transform duration-200 active:scale-[0.99]"
        >
          <img
            src={m.src}
            alt={m.alt}
            loading="lazy"
            className="w-full h-auto block"
            onError={() => setMissing((s) => ({ ...s, [m.id]: true }))}
          />
          <span className="absolute bottom-3 right-3 inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-black/70 border border-neon/60 text-[10px] uppercase tracking-[0.2em] text-white">
            <ZoomIn size={14} className="text-neon" /> Tap to enlarge
          </span>
        </button>
      ))}
      {open && <Lightbox img={open} onClose={() => setOpen(null)} />}
    </div>
  );
}
